import type { TFunction } from 'i18next';
import { z } from 'zod';

import { HcpSchema } from '@/core/graphql/generated/validation.zod';

export const DemographicsSectionSchema = (t?: TFunction) => {
	const raw = HcpSchema().pick({
		languageCda_V: true,
		gender_V: true,
		birthYear_V: true,
		dataPrivacyOptOut_V: true
	});

	const currentYear = new Date().getFullYear();

	const birthYearErrorMsg = t
		? t(`Year must be between 1900 and {{currentYear}}`, { currentYear })
		: `Year must be between 1900 and ${currentYear}`;

	return z.object({
		languageCda_V: raw.shape.languageCda_V
			.pipe(z.string())
			.transform(s => s.trim()),

		gender_V: raw.shape.gender_V
			.pipe(z.string())
			.transform(s => s.trim())
			.optional(),

		birthYear_V: raw.shape.birthYear_V
			.pipe(z.number().int())
			.refine(y => y >= 1900 && y <= currentYear, {
				message: birthYearErrorMsg
			})
			.optional(),

		dataPrivacyOptOut_V: raw.shape.dataPrivacyOptOut_V
			.transform(v => (v ? true : false))
			.pipe(z.boolean())
	});
};

export type DemographicsSectionValuesIn = z.input<
	ReturnType<typeof DemographicsSectionSchema>
>;
export type DemographicsSectionValuesOut = z.output<
	ReturnType<typeof DemographicsSectionSchema>
>;
